import {
  CallQueueItem,
  MessageQueueItem,
  MessageThread,
  PhoneCall,
  PopupQueueItem,
  PopupQueueItemType,
  PopupQueueItemTypes,
} from '@mangovoice/types'

const addItemToQueue = (
  queue: PopupQueueItem[],
  item: PopupQueueItem,
  type: PopupQueueItemType,
): MessageQueueItem[] | CallQueueItem[] => {
  const _id =
    type === PopupQueueItemTypes.CALL
      ? (item as PhoneCall).callUuid
      : (item as MessageThread).latest_message?.id || (item as MessageThread).id

  if (!_id) {
    console.error('Could not add item to queue.  Missing id.')
    return [...queue]
  }

  const newItem: PopupQueueItem = {
    ...item,
    _id,
    type,
  } as MessageQueueItem | CallQueueItem

  return [...queue, newItem] // Create a NEW array with the new item
}

export const addPhoneCallToQueue = (
  queue: PopupQueueItem[],
  call: PhoneCall,
): PopupQueueItem[] => {
  return addItemToQueue(queue, call as CallQueueItem, PopupQueueItemTypes.CALL)
}

export const addMessageToQueue = (
  queue: MessageQueueItem[],
  messages: MessageThread[],
): MessageQueueItem[] => {
  return messages.reduce(
    (newQueue, message) => {
      return addItemToQueue(
        newQueue,
        message as MessageQueueItem,
        PopupQueueItemTypes.MESSAGE,
      ) as MessageQueueItem[]
    },
    [...queue],
  )
}

export const removeItemFromQueueById = (
  queue: PopupQueueItem[],
  id: string,
): PopupQueueItem[] => {
  return queue.filter((item) => item._id !== id)
}

export const removeItemFromQueueByType = (
  queue: PopupQueueItem[],
  type: PopupQueueItemType,
): PopupQueueItem[] => {
  return queue.filter((item) => item.type !== type)
}

export const queueContainsCall = (queue: PopupQueueItem[]): boolean => {
  return queue.some((item) => item.type === PopupQueueItemTypes.CALL)
}
